import React from 'react';
import Sidebar from '../../../views/components/Sidebar';
import Logo from '../../../images/svg/logo';
import LogoMin from '../../../images/svg/logoMin';
import { Box, Divider } from '@mui/material';
import HeaderWithLogo from '../../../views/components/Sidebar/HeaderWithLogo';
import CompanyFilter from '../../../views/components/CompanyFilter';
import { ApiDocsNavItem, HelpCenterNavItem } from 'src/common/sidebar';
import PortalLogo from 'src/PlatformPortal/PortalLogo';

export default function SuperdashboardSidebar() {
  return (
    <Sidebar isOpen>
      <HeaderWithLogo
        openLogo={
          <PortalLogo
            fallback={<Logo />}
            width={133}
            height={36}
            variant="contrast"
          />
        }
        closedLogo={
          <PortalLogo
            fallback={<LogoMin />}
            width={24}
            height={24}
            compact
            variant="contrast"
          />
        }
      />
      <CompanyFilter />
      <Box sx={{ position: 'fixed', left: 0, bottom: 5 }}>
        <Divider sx={{ width: '320px' }} />
        <HelpCenterNavItem />
        <ApiDocsNavItem />
        <Divider sx={{ width: '320px' }} />
      </Box>
    </Sidebar>
  );
}
